import { Message } from "primereact/message";
import { Skeleton } from "primereact/skeleton";
import {
  ControlErrors,
  useControlContext,
  Validators,
} from "rectangular-forms";

export const TemplateInputContainer = (props) => {
  const {
    label,
    children,
    color,
    marginBottom,
    position,
    positionContainer,
    marginTop,
  } = props;
  const { validationErrors, status, control } = useControlContext();
  const isRequired = control?.hasValidator(Validators.required);
  const loadStatus = props.loadStatus || "SUCCESS";
  return (
    <>
      <div
        style={{
          marginTop: marginTop ? marginTop : "0",
          color: color,
          position: positionContainer ? positionContainer : "relative",
        }}
      >
        <div>
          <div
            style={{
              marginBottom: marginBottom ? marginBottom : "1.4rem",
              fontSize: "1.4rem",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <label
              style={{
                color: validationErrors ? "red" : color ? color : "#08082B",
              }}
            >
              <b>
                {label}
                {isRequired && label && " (*)"}
              </b>
            </label>
          </div>
          {status === "SUCCESS" && loadStatus === "SUCCESS" && (
            <div> {children}</div>
          )}
          {status === "PROCESSING" ||
            (loadStatus === "PROCESSING" && (
              <Skeleton height="5rem"></Skeleton>
            ))}
        </div>
        <ControlErrors>
          {(message) => {
            return (
              <Message
                severity="error"
                text={message}
                style={{ position: position ? position : "relative" }}
              ></Message>
            );
          }}
        </ControlErrors>
      </div>
    </>
  );
};
